import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="turnos-form-validation"
export default class extends Controller {
  static targets = [
    "targetInput",
    "targetHidden",
    "targetError",
    "patientInput",
    "patientHidden",
    "patientError",
    "submit"
  ]

  static values = {
    readonly: Boolean
  }

  connect() {
    this.validate()
  }

  onTargetInput() {
    this.clearHiddenIfTyped(this.targetInputTarget, this.targetHiddenTarget)
    this.validate()
  }

  onPatientInput() {
    this.clearHiddenIfTyped(this.patientInputTarget, this.patientHiddenTarget)
    this.validate()
  }

  onTargetSelected() {
    this.validate()
  }

  onPatientSelected() {
    this.validate()
  }

  validate() {
    if (!this.hasSubmitTarget) return

    if (this.readonlyValue) {
      this.submitTarget.disabled = true
      return
    }

    const targetOk = this.validTargetSelected()
    const patientOk = this.validPatientSelected()

    this.renderFieldState(
      this.targetInputTarget,
      this.targetErrorTarget,
      targetOk,
      "Debes seleccionar un profesional o servicio desde la lista."
    )

    this.renderFieldState(
      this.patientInputTarget,
      this.patientErrorTarget,
      patientOk,
      "Debes seleccionar un paciente desde la lista."
    )

    this.submitTarget.disabled = !(targetOk && patientOk)
  }

  validTargetSelected() {
    const visible = (this.targetInputTarget.value || "").trim()
    const hidden = (this.targetHiddenTarget.value || "").trim()

    if (visible.length === 0) return false
    if (hidden.length === 0) return false

    return /^(prof:|srv:|\d+$)/.test(hidden)
  }

  validPatientSelected() {
    const visible = (this.patientInputTarget.value || "").trim()
    const hidden = (this.patientHiddenTarget.value || "").trim()

    if (visible.length === 0) return false
    if (hidden.length === 0) return false

    return /^\d+$/.test(hidden)
  }

  clearHiddenIfTyped(visibleInput, hiddenInput) {
    const visible = (visibleInput.value || "").trim()
    const hidden = (hiddenInput.value || "").trim()

    if (!visible || !hidden) {
      hiddenInput.value = ""
      return
    }

    if (!this.hasFocusWithinField(visibleInput)) return

    hiddenInput.value = ""
  }

  hasFocusWithinField(field) {
    return document.activeElement === field
  }

  renderFieldState(input, errorEl, valid, message) {
    const showError = !valid

    input.classList.toggle("is-invalid", showError)
    input.setAttribute("aria-invalid", showError ? "true" : "false")

    if (showError) {
      errorEl.textContent = message
      errorEl.classList.remove("d-none")
    } else {
      errorEl.textContent = ""
      errorEl.classList.add("d-none")
    }
  }
}
